import React from 'react';

import { useParams } from 'react-router-dom';

import { translatedNames } from 'constants/routes';

import GrayText from './GrayText';
import ModalSection from './Section';

export default function Header(props) {
  const { content } = useParams<GeneralRoute>();
  return (
    <ModalSection {...props}>
      <GrayText variant="largeBold">Filtrar {translatedNames[content]}</GrayText>
    </ModalSection>
  );
}
